export default __webpack_public_path__ + "static/media/sq-github.138944ee.png";